import React from 'react';

import PropTypes from 'prop-types';

import { HeightUpdater } from 'util/HeightUpdater';
import { hasKey, isNotEmpty } from 'util/utils';

function Component(props, forwardedRef) {
  const { tag = 'div', subtractFrom, adjustment, isRelative, hide, ...restProps } = props;

  const ref = React.useRef();
  if (hasKey(forwardedRef, 'current')) forwardedRef.current = ref.current;

  const heightUpdater = React.useMemo(() => {
    return new HeightUpdater(subtractFrom, ref, adjustment, isRelative);
  }, [ref, subtractFrom, adjustment, isRelative]);

  const setDefaultStyles = React.useCallback(() => {
    if (ref.current?.style) {
      const defaultStyle = { height: 'auto', overflow: 'auto' };

      ref.current.style.height = ref.current.style.height || defaultStyle.height;
      ref.current.style.overflow = ref.current.style.overflow || defaultStyle.overflow;
    }
  }, []);

  React.useEffect(() => {
    heightUpdater.setHeight();
    heightUpdater.addListener();

    return () => {
      heightUpdater.removeListener();
    };
  }, [heightUpdater, setDefaultStyles]);

  React.useLayoutEffect(() => {
    setDefaultStyles();
    heightUpdater.setHeight();
  });

  if (hide) return null;

  return React.createElement(tag, { ref, ...restProps });
}

export const GridHeightContainer = React.memo(React.forwardRef(Component));
GridHeightContainer.selectors = (list) => list.filter(isNotEmpty).join(',');

GridHeightContainer.displayName = 'GridHeightContainer';

GridHeightContainer.propTypes = {
  tag: PropTypes.string,
  subtractFrom: PropTypes.any,
  adjustment: PropTypes.number,
  isRelative: PropTypes.bool,
};

export default GridHeightContainer;
